import { Icon } from './gassan-ui'
import { Heading, Text } from '@gassan-ui'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

type NewAtGassanProps = {
  variant?: 'slim' | 'full'
}

export const NewAtGassan: FC<NewAtGassanProps> = ({ variant = 'full' }) => {
  const { t } = useTranslation('account')

  const privilegeStyle = 'grid grid-cols-[auto_1fr] items-center gap-x-3 gap-y-2 text-tabaccoBrown'

  return (
    <div className="mb-6">
      {variant === 'full' && (
        <>
          <Heading as="h3" variant="h3" className="mb-2">
            {t('newAtGassan.title')}
          </Heading>
          <Text variant="regular" className="mb-6">
            {t('newAtGassan.subtitle')}
          </Text>
        </>
      )}
      <div>
        <div className={privilegeStyle}>
          <Icon icon="account-giftcard" />
          <Text variant="regular" className="mb-0">
            {t('newAtGassan.gifts')}
          </Text>
        </div>
        <div className={privilegeStyle}>
          <Icon icon="account-events" />
          <Text variant="regular" className="mb-0">
            {t('newAtGassan.events')}
          </Text>
        </div>
        <div className={privilegeStyle}>
          <Icon icon="account-privileges" />
          <Text variant="regular" className="mb-0">
            {t('newAtGassan.service')}
          </Text>
        </div>
        <div className={privilegeStyle}>
          <Icon icon="account-diamond-document" />
          <Text variant="regular" className="mb-0">
            {t('newAtGassan.save')}
          </Text>
        </div>
      </div>
    </div>
  )
}
